import { marked } from 'marked';

export default function MarkdownView({ markup }: { markup: string }) {
    function getMarkup() {
        const rawMarkup = marked.parse(markup);
        return { __html: rawMarkup };
    }
    return (
        <div dangerouslySetInnerHTML={getMarkup()} />
    )
}

export function markdownToHtml(markup: string) {
    return marked.parse(markup)
}